import request from '@/config/axios';

/** 景区发票申请 VO */
export interface ScenicInvoiceVO {
  id: number;
  userId: number;
  orderId: number;
  orderNo: string;
  scenicName?: string;
  title: string;
  taxNo?: string;
  email?: string;
  /** 开票金额（分） */
  amount: number;
  /** 状态：1=待处理，2=已开票 */
  status: number;
  invoiceNo?: string;
  invoiceTime?: string;
  createTime: string;
}

/** 景区发票申请分页查询 */
export const getScenicInvoicePage = (params: { pageNo?: number; pageSize?: number; keyword?: string; status?: number }) =>
  request.get<{ list: ScenicInvoiceVO[]; total: number }>({ url: '/scenic/invoice/page', params });

/** 开票（填写发票号） */
export const issueScenicInvoice = (id: number, invoiceNo: string) =>
  request.put<boolean>({ url: '/scenic/invoice/issue', data: { id, invoiceNo } });

/** 删除发票申请 */
export const deleteScenicInvoice = (id: number) =>
  request.delete<boolean>({ url: '/scenic/invoice/delete', params: { id } });
